import * as React from 'react'

export type BodyProps = React.ComponentPropsWithoutRef<'tbody'>
export const Body = (props: BodyProps) => <tbody {...props} />
